import { Collection1k04j3hzsbod0 as Collection } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Collections.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { intersect7qttw6wlmz1n as intersect } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { emptySetcxexqki71qfa as emptySet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Sets.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { onRemove3k528udkni1ni as onRemove } from '../../../../reactive/com/lightningkite/reactive/context/CalculationContext.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { listOfvhqybd2zx248 as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function isUnread(_this__u8e3s4, id) {
  return !_this__u8e3s4.v91().t1(id);
}
function isUnread_0(_this__u8e3s4, id) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.any' call
    var tmp;
    if (isInterface(_this__u8e3s4, Collection())) {
      tmp = _this__u8e3s4.i1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = false;
      break $l$block_0;
    }
    var _iterator__ex2g4s = _this__u8e3s4.m1();
    while (_iterator__ex2g4s.n1()) {
      var element = _iterator__ex2g4s.o1();
      if (!element.v91().t1(id)) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
    }
    tmp$ret$0 = false;
  }
  return tmp$ret$0;
}
function readByIntersection(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4.i1()) {
    tmp = emptySet();
  } else {
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().u(collectionSizeOrDefault(_this__u8e3s4, 10));
    var _iterator__ex2g4s = _this__u8e3s4.m1();
    while (_iterator__ex2g4s.n1()) {
      var item = _iterator__ex2g4s.o1();
      var tmp$ret$0 = item.v91();
      destination.v(tmp$ret$0);
    }
    // Inline function 'kotlin.collections.reduce' call
    var iterator = destination.m1();
    if (!iterator.n1())
      throw UnsupportedOperationException().i5("Empty collection can't be reduced.");
    var accumulator = iterator.o1();
    while (iterator.n1()) {
      var tmp0 = accumulator;
      var readBy = iterator.o1();
      accumulator = intersect(tmp0, readBy);
    }
    tmp = accumulator;
  }
  return tmp;
}
function isUnread_1(_this__u8e3s4, id) {
  return !_this__u8e3s4.t1(id);
}
function *_generator_markAsReadUpdateOnRemove__7fvkav(_this__u8e3s4, scope, items, $completion) {
  var tmp = _this__u8e3s4.gf9(items, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp0_safe_receiver = tmp;
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    onRemove(scope, tmp0_safe_receiver);
  }
  return Unit_instance;
}
function markAsReadUpdateOnRemove(_this__u8e3s4, scope, items, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_markAsReadUpdateOnRemove__7fvkav.bind(VOID, _this__u8e3s4, scope, items), $completion);
}
function markAsRead(_this__u8e3s4, item, $completion) {
  return _this__u8e3s4.hf9(listOf(item), $completion);
}
function handleOne(_this__u8e3s4, item) {
  return _this__u8e3s4.if9(VOID, ($this$handle, it) => {
    // Inline function 'com.lightningkite.reactive.context.TypedReactiveContext.invoke' call
    var tmp$ret$0 = item($this$handle, it);
    return listOf(tmp$ret$0);
  });
}
//region block: exports
export {
  handleOne as handleOne3ny7r4k654tcd,
  isUnread as isUnread2u0ehyt0ioouz,
  isUnread_1 as isUnread3o34h317z0nzb,
  isUnread_0 as isUnread2wfj6ps7oiv9h,
  readByIntersection as readByIntersection2rlpnb08zldsj,
  markAsReadUpdateOnRemove as markAsReadUpdateOnRemovek70bbxx94h7h,
  markAsRead as markAsRead30n3njkh9wkat,
};
//endregion

//# sourceMappingURL=HasReadBy.ext.mjs.map
